import Logo from "@/components/logo";
import { cn } from "@/lib/utils";
export default function VenueCardNoImg({ type }: { type?: number }) {
  return (
    <div className={cn("relative w-full aspect-square h-full", type != 0 && "w-[354px]")}>
      <div
        className={
          "absolute inset-0 w-full h-full " +
          (type != 0 && "rounded-2xl bg-black opacity-50")
        }
      />
      <div className="flex justify-center items-center w-full h-full relative">
        <Logo />
      </div>
    </div>
  );
}
